import * as domHelpers from "../../scripts/utils/domHelpers.js";
import Disclosure from "../../scripts/utils/Disclosure.js";

class MyAccount {
    constructor() {
        this.accountNavigation();
        this.wrapHeader();
    }

    wrapHeader() {
        const allElements = Array.from(
            document.querySelectorAll(".MyAccount > *"),
        );

        const firstH2Index = allElements.findIndex(
            (element) => element.tagName === "H2",
        );

        if (firstH2Index === -1) return;

        // Select all elements up to and including the first H2
        const headerElements = allElements.slice(0, firstH2Index + 1);

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: "spektrix-page-header",
        });
    }

    accountNavigation() {
        const options = document.querySelector(".Options");

        if (!options) return;

        // Set role attribute
        options.querySelector(".Options ul").role = "list";

        // Move the account navigation to the top of the page
        domHelpers.insertElementBefore(
            document.querySelector(".SpektrixPage"),
            options,
        );

        // Create desktop navigation markup
        const desktopNavHtml = `
            <div class="spektrix-account-nav spektrix-account-nav--desktop d-none l:d-block">
                <div class="spektrix-account-nav__inner">
                    ${options.outerHTML}
                </div>
            </div>
        `;

        // Convert the HTML string into DOM elements
        const desktopNav = document
            .createRange()
            .createContextualFragment(desktopNavHtml).firstElementChild;

        // Replace the options with the desktopnav
        options.replaceWith(desktopNav);

        // Create mobile navigation markup
        const mobileNavHtml = `
            <div class="spektrix-account-nav spektrix-account-nav--mobile l:d-none">
                <div class="spektrix-account-nav__inner">
                    <button type="button" aria-expanded="false"
                        aria-controls="spektrix-account-nav-dropdown"
                        class="spektrix-account-nav__toggle">
                        In this section
                    </button>
                    <div id="spektrix-account-nav-dropdown" class="spektrix-account-nav__content"
                        aria-hidden="true" hidden
                        data-disclosure data-disclosure-animate="true">
                        ${
                            options.querySelector(".Options ul").cloneNode(true)
                                .outerHTML
                        }
                    </div>
                </div>
            </div>
        `;

        // Convert the HTML string into DOM elements
        const mobileNav = document
            .createRange()
            .createContextualFragment(mobileNavHtml).firstElementChild;

        // Add the mobile navigation after the desktop navigation
        domHelpers.insertElementAfter(desktopNav, mobileNav);

        // Initialize dropdown behavior
        new Disclosure(
            mobileNav.querySelector(".spektrix-account-nav__content"),
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".SpektrixPage.MyAccount");

    if (pageSelector) {
        new MyAccount();
    }
});
